import React, { useContext } from "react";
import PropTypes from "prop-types";
import Overlay from "../../../Overlay";
import { format } from "date-fns";
import ProfileContext from "../../ProfileContext";
import { langComponent } from "../../../../constants";
import AppContext from "../../../../AppContext";

const View = ({ cert, onClose }) => {
  const { name, issuer, effectiveDate, dueDate, url, data } = cert;

  const { isOwner } = useContext(ProfileContext);
  const { getLang } = useContext(AppContext);
  const Translation = getLang(langComponent.certificate);

  const getPeriod = () => {
    return `${format(new Date(effectiveDate), "MMM yyyy")}${
      dueDate ? `- ${format(new Date(dueDate), "MMM yyyy")}` : ""
    }`;
  };

  const handleOpenUri = (uri) => {
    const newUri =
      uri.startsWith("http://") || uri.startsWith("https://")
        ? uri
        : "https://" + uri;
    window.open(newUri, "_blank");
  };

  return (
    <Overlay
      onClose={onClose}
      content={
        <div className="profile-card-certs-modal-view">
          <h1 className="profile-card-certs-modal-view__title">{name}</h1>
          <h2 className="profile-card-certs-modal-view__sub">
            {Translation("Issued by")} {issuer}
          </h2>
          <div className="profile-card-certs-modal-view__period">
            {getPeriod()}
          </div>
          {url && (
            <div className="profile-card-certs-modal-view-url">
              <label className="profile-card-certs-modal-view-url__title">
                {Translation("URL")}
              </label>
              <a
                className="profile-card-certs-modal-view-url__value"
                href="#"
                onClick={() => handleOpenUri(url)}
              >
                {url}
              </a>
            </div>
          )}
          {data && (
            <div className="profile-card-certs-modal-view-file">
              <label className="profile-card-certs-modal-view-file__title">
                {Translation("File")}
              </label>
              <img
                className="profile-card-certs-modal-view-file__image"
                alt="cert-file"
                src={data.file}
              />
            </div>
          )}
          {isOwner && <></>}
        </div>
      }
    />
  );
};

View.propTypes = {};

export default View;
